module.exports = __webpack_public_path__ + "img/science_thumbnail-600x450.4a2be2b4.jpg";